import React from "react";
import footerlogo from "../../assets/images/Logo.png";
import "../Footer/Footer.css";
import febicon from "../../assets/images/fb-icon.png";
import youtubicon from "../../assets/images/youTube.png";
import instaicon from "../../assets/images/insta-icon.png";
import twittericon from "../../assets/images/twitter-icon.png";
import tiktokicon from "../../assets/images/tiktokk.png";
import { Link, useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="footer">
      <div className="containerall">
        <div className="eightdiv">
          <div className="footer-logo">
            <img src={footerlogo} alt="logo" className="footerImage" />
          </div>
          <div className="footer-links">
            {/* <span className="footer-copy">© 2025 | </span> */}
            {/* <Link to="/privacypolicy" className="footer-link">
              Privacy Policy
            </Link> */}
            <a
              href="https://connecttovow.com/PrivacyPolicy"
              className="footer-link"
            >
              Privacy Policy
            </a>
            <span className="footer-copy"> | </span>
            {/* <Link to="/termsandcondition" className="footer-link">
              Terms & Conditions
            </Link> */}
            <a
              href="https://connecttovow.com/TermsCondition"
              className="footer-link"
            >
              Terms & Conditions
            </a>
            <span className="footer-copy"> | </span>
            <a href="https://connecttovow.com/Gdpr" className="footer-link">
              GDPR
            </a>
            <span className="footer-copy"> | </span>
            <a href="https://connecttovow.com/Csae" className="footer-link">
              CSAE
            </a>
            <span className="footer-copy"> | </span>
            {/* <Link to="/Blog" className="footer-link">
              Blogs
            </Link> */}
            <a href="https://connecttovow.com/Blogs" className="footer-link">
              Blogs
            </a>
            <span className="footer-copy"> | </span>
            {/* <Link to="/contact" className="footer-link">
              Contact
            </Link> */}
            <a href="https://connecttovow.com/Contact" className="footer-link">
              Contact
            </a>
            <span className="footer-copy"> | </span>
            <span
              onClick={() => {
                const storedInfluencer = localStorage.getItem("influencerData");
                if (storedInfluencer) {
                  navigate("/InfluencerPage");
                } else {
                  navigate("/AffiliateAccess");
                }
              }}
              className="footer-link"
              style={{ cursor: "pointer" }}
            >
              Affiliate Access
            </span>
          </div>
          <div className="footer-dots">
            <Link
              to="https://www.facebook.com/share/172oegxv7N/?mibextid=wwXIfr"
              target="_blank"
            >
              <img src={febicon} alt="logo" className="dot-logo" />
            </Link>
            <Link
              to="https://x.com/connecttovow?s=11&t=nxy0HnLG61uQ219xvGDkPQ"
              target="_blank"
            >
              <img src={twittericon} alt="logo" className="dot-logo" />
            </Link>

            <Link
              to="https://youtube.com/@connecttovow?si=MxIQFmayJErGCx4q"
              target="_blank"
            >
              <img src={youtubicon} alt="logo" className="youdot-logo" />
            </Link>
            <Link
              to="https://www.instagram.com/connecttovow?igsh=MW55MzhyZ3N6cW15NA%3D%3D&utm_source=qr"
              target="_blank"
            >
              <img src={instaicon} alt="logo" className="dot-logo" />
            </Link>
            <Link
              to="https://www.tiktok.com/@connecttovow?_t=ZN-8xiWRlLjAXe&_r=1"
              target="_blank"
            >
              <img src={tiktokicon} alt="logo" className="youdot-logo" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
